function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_1_"
}, React.createElement("rect", {
  className: "br0",
  height: 298.7,
  id: "XMLID_305_",
  width: 512,
  y: 106.7
}), React.createElement("polygon", {
  className: "br1",
  id: "XMLID_304_",
  points: "78.9,256 256,369.1 433.1,256 256,142.9  "
}), React.createElement("path", {
  className: "br2",
  d: "M330.7,256c0,41.2-33.5,74.7-74.7,74.7c-41.2,0-74.7-33.4-74.7-74.7   c0-41.2,33.4-74.7,74.7-74.7C297.2,181.3,330.7,214.8,330.7,256",
  id: "XMLID_303_"
}), React.createElement("path", {
  className: "br3",
  d: "M213.3,224c-8.7,0-17.3,0.6-25.6,1.8c-1.6,3.7-2.9,7.5-4,11.4c9.6-1.7,19.5-2.6,29.6-2.6   c43.8,0,83.7,16.5,113.9,43.6c1.2-3.8,2.1-7.8,2.7-11.8C298.4,240,257.7,224,213.3,224",
  id: "XMLID_302_"
}), React.createElement("path", {
  className: "br4",
  d: "M192.3,234.2c1.8-0.2,3-2,2.7-3.9c-0.2-1.9-1.9-3.4-3.6-3.1c-1.8,0.2-3,2-2.7,3.9   C189,233,190.6,234.4,192.3,234.2 M192.2,232.9c1-0.1,1.7-1.2,1.6-2.4c-0.2-1.2-1.1-2.1-2.1-2c-1,0.1-1.7,1.2-1.6,2.4   C190.2,232.1,191.1,233,192.2,232.9"
}), React.createElement("path", {
  className: "br4",
  d: "M198.1,233.5l1.3-0.1l-0.2-2.6l2.8-0.2c1.2-0.1,2.2-1.2,2.1-2.4c-0.1-1.2-1.1-2.2-2.4-2.1l-4.1,0.3   L198.1,233.5z M199.2,229.5l2.7-0.2c0.5,0,0.9-0.5,0.8-1c0-0.5-0.5-0.9-1-0.8l-2.7,0.2L199.2,229.5z"
}), React.createElement("path", {
  className: "br0",
  d: "M204.1,233.1c-0.1-1-0.2-3.3-1.7-3.1l-1.9,0.1c2.2-0.2,2.4,2.1,2.4,3.1",
  id: "XMLID_297_"
}), React.createElement("path", {
  className: "br4",
  d: "M207.1,233l3.4-0.1c1.7,0,3-1.4,3-3.1l0-1c0-1.7-1.4-3-3.1-3l-3.4,0.1L207.1,233z M208.4,231.6l1.9,0   c1.1,0,1.9-0.9,1.9-2l0-0.6c0-1.1-0.9-1.9-2-1.9l-1.9,0L208.4,231.6z"
}), React.createElement("polygon", {
  className: "br0",
  id: "XMLID_294_",
  points: "216.2,232.9 222.6,233.1 222.6,231.8 217.4,231.6 217.5,229.8 221.6,229.9    221.6,228.7 217.5,228.6 217.6,227.1 222.5,227.3 222.5,226 216.4,225.8  "
}), React.createElement("polygon", {
  className: "br0",
  id: "XMLID_293_",
  points: "225.2,233.3 226.4,233.4 226.8,228.5 227.8,233.5 228.9,233.6 230.8,228.9    230.3,233.7 231.6,233.8 232.2,226.7 230.4,226.6 228.6,231.3 227.6,226.3 225.8,226.2  "
}), React.createElement("polygon", {
  className: "br0",
  id: "XMLID_292_",
  points: "239.9,234.9 245.2,235.8 245.4,234.6 241.3,233.9 241.6,232.3 244.9,232.9    245.1,231.7 241.8,231.1 242,230 245.9,230.7 246.1,229.5 241,228.6  "
}), React.createElement("path", {
  className: "br4",
  d: "M253.4,237.6l1.3,0.3l0.7-2.5l2.8,0.7c1.2,0.3,2.4-0.4,2.7-1.6c0.3-1.2-0.4-2.4-1.6-2.7l-3.9-1L253.4,237.6z    M255.7,234.1l2.7,0.7c0.5,0.1,1-0.2,1.1-0.7c0.1-0.5-0.2-1-0.7-1.1l-2.7-0.7L255.7,234.1z"
}), React.createElement("path", {
  className: "br4",
  d: "M262.1,239.9l1.3,0.4l0.8-2.5l2.7,0.9c1.2,0.4,2.4-0.3,2.8-1.5c0.4-1.2-0.3-2.4-1.5-2.8l-3.9-1.2L262.1,239.9z    M264.6,236.5l2.6,0.8c0.5,0.2,1-0.1,1.2-0.6c0.2-0.5-0.1-1-0.6-1.2l-2.6-0.8L264.6,236.5z"
}), React.createElement("path", {
  className: "br0",
  d: "M267.9,241.7c0.3-1,1-3.1-0.5-3.6l-1.8-0.6c2.1,0.7,1.5,2.8,1.1,3.8",
  id: "XMLID_287_"
}), React.createElement("path", {
  className: "br4",
  d: "M273.7,243.8c1.7,0.6,3.6-0.4,4.2-2.2c0.7-1.8-0.1-3.8-1.8-4.5c-1.7-0.6-3.6,0.4-4.2,2.2   C271.3,241.2,272.1,243.2,273.7,243.8 M274.2,242.6c1,0.4,2.1-0.3,2.5-1.4c0.4-1.2,0-2.4-1-2.8c-1-0.4-2.1,0.3-2.5,1.4   C272.8,241,273.2,242.2,274.2,242.6"
}), React.createElement("path", {
  className: "br4",
  d: "M282.1,247.2c1.6,0.7,3.6-0.2,4.4-2c0.8-1.8,0.1-3.8-1.5-4.5c-1.6-0.7-3.6,0.2-4.4,2   C279.8,244.4,280.5,246.5,282.1,247.2 M282.6,246c0.9,0.4,2.1-0.2,2.6-1.3c0.5-1.1,0.1-2.4-0.8-2.8c-0.9-0.4-2.1,0.2-2.6,1.3   C281.3,244.3,281.7,245.6,282.6,246"
}), React.createElement("polygon", {
  className: "br0",
  id: "XMLID_282_",
  points: "284,244.1 286.5,245.2 286,246.1 283.6,245  "
}), React.createElement("polygon", {
  className: "br0",
  id: "XMLID_281_",
  points: "285.5,244.8 286.5,245.2 285,248.5 284.1,248.1  "
}), React.createElement("path", {
  className: "br4",
  d: "M287.4,249.6l1.2,0.6l1.2-2.4l2.5,1.3c1.1,0.6,2.5,0.1,3-1c0.5-1.1,0.1-2.4-1-3l-3.6-1.8L287.4,249.6z    M290.4,246.6l2.5,1.2c0.5,0.2,1,0,1.2-0.4c0.2-0.5,0-1-0.4-1.2l-2.5-1.2L290.4,246.6z"
}), React.createElement("path", {
  className: "br0",
  d: "M292.8,252.3c0.5-0.9,1.4-2.9,0.1-3.6l-1.7-0.9c2,1,1,3,0.5,3.9",
  id: "XMLID_278_"
}), React.createElement("polygon", {
  className: "br0",
  id: "XMLID_277_",
  points: "295.5,253.7 301,256.8 301.7,255.7 297.2,253.1 298.1,251.5 301.6,253.5 302.2,252.5    298.7,250.5 299.4,249.2 303.6,251.6 304.3,250.5 299,247.5  "
}), React.createElement("path", {
  className: "br0",
  d: "M305.8,257.1c-0.4,0.6,0,1.3,0.9,1.8c0.9,0.5,1.4,0.5,1.7,0.1c0.8-1.2-3.7-3-2.3-5.1   c1.2-1.8,3.2-0.4,4,0.1c0.8,0.5,2,1.8,1,3.2l-1.3-0.8c0.4-0.6,0-1.3-0.7-1.7c-0.6-0.4-1.2-0.6-1.6,0c-0.7,1,3.7,2.9,2.4,5   c-1,1.6-2.7,0.9-3.9,0.1c-1-0.6-2.5-2.1-1.5-3.6L305.8,257.1z",
  id: "XMLID_276_"
}), React.createElement("path", {
  className: "br0",
  d: "M313.5,262.2c-0.4,0.6-0.1,1.3,0.8,1.9c0.8,0.6,1.4,0.6,1.7,0.2c0.8-1.2-3.6-3.2-2.1-5.2   c1.3-1.8,3.3-0.2,4,0.3c0.7,0.5,1.9,1.9,0.9,3.3l-1.3-0.9c0.4-0.6,0-1.3-0.6-1.7c-0.6-0.5-1.2-0.7-1.6-0.1   c-0.7,0.9,3.6,3.1,2.1,5.1c-1.1,1.5-2.8,0.7-3.9,0c-0.9-0.7-2.3-2.2-1.3-3.7L313.5,262.2z",
  id: "XMLID_275_"
}), React.createElement("path", {
  className: "br4",
  d: "M320.7,270.4c1.4,1.1,3.5,0.7,4.7-0.8c1.2-1.5,1.1-3.7-0.3-4.8c-1.4-1.1-3.5-0.8-4.7,0.8   C319.2,267.1,319.3,269.3,320.7,270.4 M321.5,269.3c0.8,0.6,2.1,0.4,2.9-0.6c0.8-1,0.7-2.3-0.1-2.9c-0.8-0.6-2.1-0.4-2.9,0.6   C320.7,267.4,320.7,268.7,321.5,269.3"
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_272_",
  points: "195.1,239.4 194.1,242.4 195.6,242.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_271_",
  points: "195.1,239.4 196,242.4 194.5,242.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_270_",
  points: "198.1,241.6 194.9,241.6 194.9,243.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_269_",
  points: "198.1,241.6 195.5,243.5 194.6,242.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_268_",
  points: "192,241.6 194.6,243.5 195.5,242.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_267_",
  points: "192,241.6 195.2,241.6 195.2,243.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_266_",
  points: "196.9,245.2 195.9,242.1 194.4,242.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_265_",
  points: "196.9,245.2 194.3,243.3 195.3,242  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_264_",
  points: "193.2,245.2 195.8,243.3 194.8,242  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_263_",
  points: "193.2,245.2 194.2,242.1 195.7,242.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_262_",
  points: "201.7,270.8 200.7,273.8 202.2,274.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_261_",
  points: "201.7,270.8 202.6,273.8 201.1,274.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_260_",
  points: "204.7,273 201.5,273 201.5,274.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_259_",
  points: "204.7,273 202.1,274.9 201.2,273.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_258_",
  points: "198.6,273 201.2,274.9 202.1,273.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_257_",
  points: "198.6,273 201.8,273 201.8,274.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_256_",
  points: "203.5,276.6 202.5,273.5 201,274  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_255_",
  points: "203.5,276.6 200.9,274.7 201.9,273.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_254_",
  points: "199.8,276.6 202.4,274.7 201.4,273.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_253_",
  points: "199.8,276.6 200.8,273.5 202.3,274  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_252_",
  points: "192.5,278.5 191.9,280.6 192.9,280.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_251_",
  points: "192.5,278.5 193.2,280.6 192.2,280.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_250_",
  points: "194.5,280 192.4,280 192.4,281.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_249_",
  points: "194.5,280 192.8,281.3 192.2,280.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_248_",
  points: "190.5,280 192.2,281.3 192.8,280.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_247_",
  points: "190.5,280 192.6,280 192.6,281.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_246_",
  points: "193.8,282.4 193.1,280.4 192.1,280.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_245_",
  points: "193.8,282.4 192,281.1 192.7,280.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_244_",
  points: "191.3,282.4 193,281.1 192.4,280.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_243_",
  points: "191.3,282.4 191.9,280.4 192.9,280.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_242_",
  points: "209,267.9 208.5,269.3 209.2,269.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_241_",
  points: "209,267.9 209.4,269.3 208.7,269.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_240_",
  points: "210.4,268.9 208.9,268.9 208.9,269.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_239_",
  points: "210.4,268.9 209.2,269.8 208.7,269.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_238_",
  points: "207.5,268.9 208.7,269.8 209.2,269.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_237_",
  points: "207.5,268.9 209,268.9 209,269.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_236_",
  points: "209.9,270.6 209.4,269.2 208.7,269.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_235_",
  points: "209.9,270.6 208.6,269.7 209.1,269.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_234_",
  points: "208.1,270.6 209.3,269.7 208.9,269.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_233_",
  points: "208.1,270.6 208.5,269.2 209.3,269.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_232_",
  points: "217.2,278.7 216.4,281.3 217.6,281.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_231_",
  points: "217.2,278.7 218,281.3 216.8,281.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_230_",
  points: "219.7,280.6 217.1,280.6 217.1,281.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_229_",
  points: "219.7,280.6 217.6,282.1 216.8,281.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_228_",
  points: "214.7,280.6 216.8,282.1 217.6,281.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_227_",
  points: "214.7,280.6 217.3,280.6 217.3,281.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_226_",
  points: "218.8,283.5 217.9,281 216.7,281.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_225_",
  points: "218.8,283.5 216.6,282 217.4,280.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_224_",
  points: "215.6,283.5 217.8,282 217,280.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_223_",
  points: "215.6,283.5 216.5,281 217.7,281.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_222_",
  points: "215,286.1 214.1,288.7 215.4,289.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_221_",
  points: "215,286.1 215.8,288.7 214.5,289.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_220_",
  points: "217.5,288 214.8,288 214.8,289.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_219_",
  points: "217.5,288 215.3,289.6 214.6,288.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_218_",
  points: "212.4,288 214.6,289.6 215.4,288.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_217_",
  points: "212.4,288 215.1,288 215.1,289.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_216_",
  points: "216.5,291 215.7,288.4 214.4,288.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_215_",
  points: "216.5,291 214.4,289.4 215.2,288.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_214_",
  points: "213.4,291 215.6,289.4 214.8,288.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_213_",
  points: "213.4,291 214.2,288.4 215.5,288.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_212_",
  points: "279.2,229.6 278.2,232.7 279.7,233.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_211_",
  points: "279.2,229.6 280.2,232.7 278.6,233.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_210_",
  points: "282.2,231.8 279,231.8 279,233.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_209_",
  points: "282.2,231.8 279.6,233.7 278.7,232.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_208_",
  points: "276.1,231.8 278.7,233.7 279.7,232.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_207_",
  points: "276.1,231.8 279.3,231.8 279.3,233.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_206_",
  points: "281,235.4 280.1,232.4 278.5,232.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_205_",
  points: "281,235.4 278.5,233.5 279.4,232.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_204_",
  points: "277.3,235.4 279.9,233.5 278.9,232.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_203_",
  points: "277.3,235.4 278.3,232.4 279.8,232.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_202_",
  points: "308.3,279 307.3,282.1 308.9,282.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_201_",
  points: "308.3,279 309.3,282.1 307.8,282.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_200_",
  points: "311.4,281.2 308.2,281.2 308.2,282.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_199_",
  points: "311.4,281.2 308.8,283.1 307.8,281.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_198_",
  points: "305.3,281.2 307.9,283.1 308.8,281.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_197_",
  points: "305.3,281.2 308.5,281.2 308.5,282.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_196_",
  points: "310.2,284.8 309.2,281.8 307.7,282.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_195_",
  points: "310.2,284.8 307.6,282.9 308.6,281.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_194_",
  points: "306.4,284.8 309,282.9 308.1,281.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_193_",
  points: "306.4,284.8 307.4,281.8 308.9,282.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_192_",
  points: "318.7,280.8 318,282.8 319,283.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_191_",
  points: "318.7,280.8 319.3,282.8 318.3,283.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_190_",
  points: "320.7,282.3 318.6,282.3 318.6,283.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_189_",
  points: "320.7,282.3 319,283.5 318.4,282.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_188_",
  points: "316.6,282.3 318.4,283.5 319,282.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_187_",
  points: "316.6,282.3 318.8,282.3 318.8,283.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_186_",
  points: "319.9,284.6 319.3,282.6 318.3,282.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_185_",
  points: "319.9,284.6 318.2,283.4 318.8,282.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_184_",
  points: "317.4,284.6 319.1,283.4 318.5,282.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_183_",
  points: "317.4,284.6 318.1,282.6 319.1,282.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_182_",
  points: "311.4,286.1 310.5,288.7 311.8,289.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_181_",
  points: "311.4,286.1 312.2,288.7 310.9,289.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_180_",
  points: "313.9,288 311.2,288 311.2,289.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_179_",
  points: "313.9,288 311.7,289.6 311,288.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_178_",
  points: "308.8,288 311,289.6 311.8,288.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_177_",
  points: "308.8,288 311.5,288 311.5,289.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_176_",
  points: "312.9,291 312.1,288.4 310.8,288.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_175_",
  points: "312.9,291 310.8,289.4 311.6,288.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_174_",
  points: "309.8,291 312,289.4 311.2,288.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_173_",
  points: "309.8,291 310.6,288.4 311.9,288.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_172_",
  points: "293.4,301.8 292.6,304.3 293.8,304.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_171_",
  points: "293.4,301.8 294.2,304.3 292.9,304.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_170_",
  points: "295.9,303.6 293.3,303.6 293.3,305  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_169_",
  points: "295.9,303.6 293.8,305.2 293,304.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_168_",
  points: "290.9,303.6 293,305.2 293.8,304.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_167_",
  points: "290.9,303.6 293.5,303.6 293.5,305  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_166_",
  points: "295,306.6 294.1,304.1 292.9,304.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_165_",
  points: "295,306.6 292.8,305 293.6,304  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_164_",
  points: "291.8,306.6 294,305 293.2,304  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_163_",
  points: "291.8,306.6 292.6,304.1 293.9,304.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_162_",
  points: "293.3,309.8 292.6,311.9 293.6,312.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_161_",
  points: "293.3,309.8 293.9,311.9 292.9,312.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_160_",
  points: "295.3,311.3 293.2,311.3 293.2,312.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_159_",
  points: "295.3,311.3 293.6,312.6 293,311.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_158_",
  points: "291.3,311.3 293,312.6 293.6,311.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_157_",
  points: "291.3,311.3 293.4,311.3 293.4,312.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_156_",
  points: "294.5,313.7 293.9,311.7 292.9,312  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_155_",
  points: "294.5,313.7 292.8,312.4 293.4,311.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_154_",
  points: "292,313.7 293.8,312.4 293.1,311.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_153_",
  points: "292,313.7 292.7,311.7 293.7,312  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_152_",
  points: "300.8,296.4 300.1,298.5 301.2,298.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_151_",
  points: "300.8,296.4 301.5,298.5 300.4,298.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_150_",
  points: "302.8,297.9 300.7,297.9 300.7,299  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_149_",
  points: "302.8,297.9 301.1,299.2 300.5,298.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_148_",
  points: "298.8,297.9 300.5,299.2 301.1,298.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_147_",
  points: "298.8,297.9 300.9,297.9 300.9,299  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_146_",
  points: "302.1,300.3 301.4,298.3 300.4,298.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_145_",
  points: "302.1,300.3 300.3,299 301,298.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_144_",
  points: "299.6,300.3 301.3,299 300.6,298.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_143_",
  points: "299.6,300.3 300.2,298.3 301.2,298.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_142_",
  points: "306.8,292.1 306,294.7 307.2,295.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_141_",
  points: "306.8,292.1 307.6,294.7 306.4,295.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_140_",
  points: "309.3,294 306.7,294 306.7,295.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_139_",
  points: "309.3,294 307.2,295.5 306.4,294.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_138_",
  points: "304.3,294 306.4,295.5 307.2,294.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_137_",
  points: "304.3,294 306.9,294 306.9,295.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_136_",
  points: "308.4,296.9 307.5,294.4 306.3,294.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_135_",
  points: "308.4,296.9 306.2,295.4 307,294.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_134_",
  points: "305.2,296.9 307.4,295.4 306.6,294.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_133_",
  points: "305.2,296.9 306.1,294.4 307.3,294.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_132_",
  points: "293.1,295 292.4,297 293.4,297.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_131_",
  points: "293.1,295 293.7,297 292.7,297.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_130_",
  points: "295.1,296.5 293,296.5 293,297.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_129_",
  points: "295.1,296.5 293.4,297.7 292.8,296.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_128_",
  points: "291.1,296.5 292.8,297.7 293.4,296.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_127_",
  points: "291.1,296.5 293.2,296.5 293.2,297.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_126_",
  points: "294.3,298.9 293.7,296.8 292.7,297.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_125_",
  points: "294.3,298.9 292.6,297.6 293.2,296.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_124_",
  points: "291.8,298.9 293.6,297.6 292.9,296.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_123_",
  points: "291.8,298.9 292.5,296.8 293.5,297.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_122_",
  points: "227.6,256.4 226.7,258.9 228,259.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_121_",
  points: "227.6,256.4 228.4,258.9 227.1,259.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_120_",
  points: "230.1,258.2 227.4,258.2 227.4,259.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_119_",
  points: "230.1,258.2 227.9,259.8 227.2,258.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_118_",
  points: "225,258.2 227.2,259.8 228,258.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_117_",
  points: "225,258.2 227.7,258.2 227.7,259.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_116_",
  points: "229.1,261.2 228.3,258.7 227,259.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_115_",
  points: "229.1,261.2 227,259.6 227.8,258.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_114_",
  points: "226,261.2 228.1,259.6 227.4,258.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_113_",
  points: "226,261.2 226.8,258.7 228.1,259.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_112_",
  points: "276.3,250.1 275.7,252.1 276.7,252.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_111_",
  points: "276.3,250.1 277,252.1 276,252.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_110_",
  points: "278.3,251.6 276.2,251.6 276.2,252.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_109_",
  points: "278.3,251.6 276.6,252.8 276,252  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_108_",
  points: "274.3,251.6 276,252.8 276.6,252  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_107_",
  points: "274.3,251.6 276.4,251.6 276.4,252.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_106_",
  points: "277.6,254 276.9,251.9 275.9,252.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_105_",
  points: "277.6,254 275.8,252.7 276.5,251.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_104_",
  points: "275.1,254 276.8,252.7 276.2,251.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_103_",
  points: "275.1,254 275.7,251.9 276.7,252.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_102_",
  points: "256,286.3 255,289.4 256.5,289.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_101_",
  points: "256,286.3 257,289.4 255.5,289.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_100_",
  points: "259,288.5 255.8,288.5 255.8,290.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_99_",
  points: "259,288.5 256.5,290.4 255.5,289.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_98_",
  points: "253,288.5 255.5,290.4 256.5,289.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_97_",
  points: "253,288.5 256.2,288.5 256.2,290.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_96_",
  points: "257.9,292.1 256.9,289.1 255.4,289.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_95_",
  points: "257.9,292.1 255.3,290.2 256.2,288.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_94_",
  points: "254.1,292.1 256.7,290.2 255.8,288.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_93_",
  points: "254.1,292.1 255.1,289.1 256.6,289.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_92_",
  points: "264.6,272 263.8,274.5 265.1,275  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_91_",
  points: "264.6,272 265.5,274.5 264.2,275  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_90_",
  points: "267.2,273.9 264.5,273.9 264.5,275.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_89_",
  points: "267.2,273.9 265,275.4 264.2,274.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_88_",
  points: "262.1,273.9 264.3,275.4 265,274.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_87_",
  points: "262.1,273.9 264.8,273.9 264.8,275.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_86_",
  points: "266.2,276.8 265.4,274.3 264.1,274.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_85_",
  points: "266.2,276.8 264,275.3 264.8,274.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_84_",
  points: "263.1,276.8 265.2,275.3 264.4,274.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_83_",
  points: "263.1,276.8 263.9,274.3 265.2,274.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_82_",
  points: "256,265.3 255.2,267.9 256.4,268.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_81_",
  points: "256,265.3 256.8,267.9 255.6,268.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_80_",
  points: "258.5,267.2 255.9,267.2 255.9,268.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_79_",
  points: "258.5,267.2 256.4,268.7 255.6,267.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_78_",
  points: "253.5,267.2 255.6,268.7 256.4,267.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_77_",
  points: "253.5,267.2 256.1,267.2 256.1,268.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_76_",
  points: "257.6,270.1 256.7,267.6 255.5,268  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_75_",
  points: "257.6,270.1 255.4,268.6 256.2,267.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_74_",
  points: "254.4,270.1 256.6,268.6 255.8,267.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_73_",
  points: "254.4,270.1 255.3,267.6 256.5,268  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_72_",
  points: "248.5,272.6 247.8,274.6 248.8,274.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_71_",
  points: "248.5,272.6 249.1,274.6 248.1,274.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_70_",
  points: "250.5,274 248.4,274 248.4,275.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_69_",
  points: "250.5,274 248.8,275.3 248.2,274.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_68_",
  points: "246.5,274 248.2,275.3 248.8,274.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_67_",
  points: "246.5,274 248.6,274 248.6,275.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_66_",
  points: "249.7,276.4 249.1,274.4 248.1,274.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_65_",
  points: "249.7,276.4 248,275.2 248.6,274.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_64_",
  points: "247.2,276.4 249,275.2 248.3,274.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_63_",
  points: "247.2,276.4 247.9,274.4 248.9,274.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_62_",
  points: "252.2,278.3 251.8,279.8 252.5,280  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_61_",
  points: "252.2,278.3 252.7,279.8 252,280  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_60_",
  points: "253.7,279.4 252.2,279.4 252.2,280.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_59_",
  points: "253.7,279.4 252.5,280.3 252,279.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_58_",
  points: "250.8,279.4 252,280.3 252.5,279.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_57_",
  points: "250.8,279.4 252.3,279.4 252.3,280.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_56_",
  points: "253.1,281.1 252.7,279.6 251.9,279.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_55_",
  points: "253.1,281.1 251.9,280.2 252.4,279.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_54_",
  points: "251.3,281.1 252.6,280.2 252.1,279.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_53_",
  points: "251.3,281.1 251.8,279.6 252.5,279.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_52_",
  points: "278.4,303.6 277.5,306.2 278.8,306.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_51_",
  points: "278.4,303.6 279.2,306.2 277.9,306.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_50_",
  points: "280.9,305.4 278.2,305.4 278.2,306.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_49_",
  points: "280.9,305.4 278.7,307 277.9,305.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_48_",
  points: "275.8,305.4 278,307 278.8,305.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_47_",
  points: "275.8,305.4 278.5,305.4 278.5,306.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_46_",
  points: "279.9,308.4 279.1,305.9 277.8,306.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_45_",
  points: "279.9,308.4 277.8,306.9 278.5,305.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_44_",
  points: "276.8,308.4 278.9,306.9 278.2,305.8  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_43_",
  points: "276.8,308.4 277.6,305.9 278.9,306.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_42_",
  points: "284.7,297.5 284.1,299.6 285.1,299.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_41_",
  points: "284.7,297.5 285.4,299.6 284.4,299.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_40_",
  points: "286.8,299 284.6,299 284.6,300.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_39_",
  points: "286.8,299 285.1,300.3 284.4,299.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_38_",
  points: "282.7,299 284.4,300.3 285.1,299.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_37_",
  points: "282.7,299 284.9,299 284.9,300.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_36_",
  points: "286,301.4 285.3,299.4 284.3,299.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_35_",
  points: "286,301.4 284.3,300.2 284.9,299.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_34_",
  points: "283.5,301.4 285.2,300.2 284.6,299.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_33_",
  points: "283.5,301.4 284.2,299.4 285.2,299.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_32_",
  points: "272.5,295.7 271.8,297.7 272.8,298.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_31_",
  points: "272.5,295.7 273.1,297.7 272.1,298.1  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_30_",
  points: "274.5,297.2 272.4,297.2 272.4,298.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_29_",
  points: "274.5,297.2 272.8,298.4 272.1,297.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_28_",
  points: "270.4,297.2 272.2,298.4 272.8,297.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_27_",
  points: "270.4,297.2 272.6,297.2 272.6,298.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_26_",
  points: "273.7,299.6 273.1,297.5 272,297.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_25_",
  points: "273.7,299.6 272,298.3 272.6,297.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_24_",
  points: "271.2,299.6 272.9,298.3 272.3,297.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_23_",
  points: "271.2,299.6 271.9,297.5 272.9,297.9  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_22_",
  points: "226,292.4 225.1,295.4 226.6,296  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_21_",
  points: "226,292.4 227,295.4 225.5,296  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_20_",
  points: "229.1,294.6 225.9,294.6 225.9,296.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_19_",
  points: "229.1,294.6 226.5,296.5 225.6,295.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_18_",
  points: "223,294.6 225.6,296.5 226.5,295.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_17_",
  points: "223,294.6 226.2,294.6 226.2,296.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_16_",
  points: "227.9,298.2 226.9,295.2 225.4,295.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_15_",
  points: "227.9,298.2 225.3,296.3 226.3,295  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_14_",
  points: "224.1,298.2 226.7,296.3 225.8,295  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_13_",
  points: "224.1,298.2 225.1,295.2 226.7,295.7  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_12_",
  points: "256,313.3 255.7,314.4 256.2,314.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_11_",
  points: "256,313.3 256.3,314.4 255.8,314.5  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_10_",
  points: "257,314.1 255.9,314.1 255.9,314.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_9_",
  points: "257,314.1 256.2,314.7 255.8,314.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_8_",
  points: "255,314.1 255.9,314.7 256.2,314.3  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_7_",
  points: "255,314.1 256.1,314.1 256.1,314.6  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_6_",
  points: "256.6,315.3 256.3,314.3 255.8,314.4  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_5_",
  points: "256.6,315.3 255.8,314.6 256.1,314.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_4_",
  points: "255.4,315.3 256.2,314.6 255.9,314.2  "
}), React.createElement("polygon", {
  className: "br3",
  id: "XMLID_3_",
  points: "255.4,315.3 255.7,314.3 256.2,314.4  "
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    version: 1.1,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/brazil.455ab8f1.svg";
export { SvgComponent as ReactComponent };